import { render, staticRenderFns } from "./PublicationHeader.vue?vue&type=template&id=7fbf1b58&scoped=true&lang=pug"
import script from "./PublicationHeader.vue?vue&type=script&lang=js"
export * from "./PublicationHeader.vue?vue&type=script&lang=js"
import style0 from "./PublicationHeader.vue?vue&type=style&index=0&id=7fbf1b58&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbf1b58",
  null
  
)

export default component.exports